export const FETCH_ME_REQUEST = '@@user/FETCH_ME_REQUEST';
export const FETCH_ME_SUCCESS = '@@user/FETCH_ME_SUCCESS';
export const FETCH_ME_FAILURE = '@@user/FETCH_ME_FAILURE';

export const SIGN_OUT_REQUEST = '@@user/SIGN_OUT_REQUEST';
export const SIGN_OUT_FAILURE = '@@user/SIGN_OUT_FAILURE';

export const SET_SESSION_INFO = '@@user/SET_SESSION_INFO';
